import { render, staticRenderFns } from "./novaPropostaRcvat.vue?vue&type=template&id=646bff6a&scoped=true"
import script from "./novaPropostaRcvat.vue?vue&type=script&lang=js"
export * from "./novaPropostaRcvat.vue?vue&type=script&lang=js"
import style0 from "./novaPropostaRcvat.vue?vue&type=style&index=0&id=646bff6a&prod&lang=scss"
import style1 from "./novaPropostaRcvat.vue?vue&type=style&index=1&id=646bff6a&prod&scoped=true&lang=css"
import style2 from "./novaPropostaRcvat.vue?vue&type=style&index=2&id=646bff6a&prod&lang=scss&scoped=true"
import style3 from "./novaPropostaRcvat.vue?vue&type=style&index=3&id=646bff6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646bff6a",
  null
  
)

export default component.exports